export const ROUTE_PATH = `/benefit/giveout`;
